import React from "react";
import { Spinner } from "./ui/spinner";

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-br from-blue-500 to-purple-600">
      <Spinner size="xl" variant="white" />
    </div>
  );
};

export default LoadingSpinner;
